// Not-yet-started, from the pickers' point of view: anything that isn't Doing
// or Done. The project also uses pre-work states like "Define Requirements" and
// "Feasibility", and those belong on the to-do side — same bucket the grey state
// dot marks.
export const isTodoWorkItem = (state: string): boolean => {
    const normalised = state.trim().toLowerCase();
    return normalised !== 'doing' && normalised !== 'done';
};
